import useMediaQuery from '@mui/material/useMediaQuery';

function useBigScreen() {
  return useMediaQuery('@media (min-width: 1200px)');
}

export default useBigScreen;
